module.exports = __webpack_public_path__ + "img/quotes_approve.5a3ea85.png";